import { fetchAction, fetchPostApi } from "../../../helpers/fetch";

export const getPaginatedNotifications = (offset, limit, isOnlyUnread = false) => {
    const queryFilters = [`limit=${limit || 10}`, `offset=${offset || 0}`];
    const filter = queryFilters.join("&");

    let successState = "GET_NOTIFICATIONS_SUCCESS";

    if (isOnlyUnread) {
        successState = "GET_UNREAD_NOTIFICATIONS_SUCCESS"
    }

    return fetchAction(`/api/notifications?${filter}`, [
        "GET_NOTIFICATIONS_REQUEST",
        successState,
        "GET_NOTIFICATIONS_FAILURE",
    ]);
};

export const updateNotificationAsRead = (notificationIds) => fetchPostApi('/api/notifications/mark-read', { ids: notificationIds }, "PATCH")